import {
  BookOpenText,
  CalendarClock,
  ClipboardCheck,
  Crosshair,
  FileInput,
  FileText,
  FileUp,
  Fuel,
  Globe2,
  LayoutGrid,
  ListTree,
  type LucideIcon,
  Map as MapIcon,
  MountainSnow,
  Network,
  NotebookPen,
  Route,
  ScrollText,
  ShieldCheck,
  Waypoints,
  Wrench,
} from "lucide-react";

import { k, t } from "../i18n/i18n";
import type { ViewKey } from "../state/ui";

/** Libellé et icône de chaque vue (R7, R15) : le titre d'une vue est son libellé de navigation, et l'icône de son
 *  en-tête ou de son panneau est celle de la barre latérale. Source unique pour la barre latérale, la recherche ⌘K,
 *  les en-têtes de vue (`ViewHeader`) et les panneaux (`FloatingPanel icon`). `label` est une clé française
 *  (`k()`), traduite à l'affichage (`viewLabel`). */
export const VIEW_META: Record<ViewKey, { label: string; icon: LucideIcon }> = {
  mission: { label: k("Données initiales"), icon: MapIcon },
  objects: { label: k("Objets de la mission"), icon: LayoutGrid },
  manoeuvre: { label: k("Manœuvre"), icon: Route },
  terrain: { label: k("Analyse du terrain"), icon: MountainSnow },
  coa: { label: k("Modes d'action"), icon: Waypoints },
  country: { label: k("Fiche pays"), icon: Globe2 },
  briefing: { label: k("Mise en ambiance"), icon: BookOpenText },
  order: { label: k("Ordre d'opérations"), icon: FileText },
  oplan: { label: k("Plan d'opération (OPLAN)"), icon: ScrollText },
  coherence: { label: k("Cohérence tactique"), icon: ShieldCheck },
  timeline: { label: k("DIREX"), icon: CalendarClock },
  evaluation: { label: k("3A"), icon: ClipboardCheck },
  exports: { label: k("Exports"), icon: FileUp },
  received: { label: k("Ordres reçus"), icon: FileInput },
  declination: { label: k("Ordres subordonnés"), icon: ListTree },
  retex: { label: k("RETEX"), icon: NotebookPen },
  logistics: { label: k("Logistique"), icon: Fuel },
  maintenance: { label: k("Maintenance"), icon: Wrench },
  orbats: { label: k("Ordres de bataille"), icon: Network },
  enemies: { label: k("ENI personnalisés"), icon: Crosshair },
};

/** Libellé traduit d'une vue. */
export function viewLabel(view: ViewKey): string {
  return t(VIEW_META[view].label);
}

/** Icône d'une vue, 16 px par défaut (en-têtes, navigation). */
export function ViewIcon({ view, size = 16, className }: { view: ViewKey; size?: number; className?: string }) {
  const Icon = VIEW_META[view].icon;
  return <Icon size={size} className={className} aria-hidden />;
}
